import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-330f80e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "footer-help pt-5" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "page-container footer-mobile" }
const _hoisted_5 = { class: "footer-mobile-left" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "footer-mobile-right" }
const _hoisted_9 = { class: "footer-mobile-right-top" }
const _hoisted_10 = { class: "phone" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt" }, null, -1))
const _hoisted_13 = { class: "email" }
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1))
const _hoisted_16 = { class: "footer-mobile-right-bottom" }
const _hoisted_17 = { class: "social-media" }
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["aria-label"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin-in" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-vimeo-v" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-pinterest" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "page-container footer-tablet mt-5" }
const _hoisted_34 = { class: "footer-tablet-column pr-6" }
const _hoisted_35 = { class: "footer-tablet-sub-column" }
const _hoisted_36 = { class: "footer-tablet-sub-column" }
const _hoisted_37 = ["href"]
const _hoisted_38 = { class: "footer-tablet-column" }
const _hoisted_39 = { class: "footer-tablet-sub-column" }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "gray" }
const _hoisted_42 = { class: "gray pb-5" }
const _hoisted_43 = { class: "footer-tablet-sub-column" }
const _hoisted_44 = ["href"]
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "gray" }
const _hoisted_47 = { class: "gray pb-5" }
const _hoisted_48 = { class: "social" }
const _hoisted_49 = ["aria-label"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["aria-label"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin-in" }, null, -1))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = ["aria-label"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = ["aria-label"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-vimeo-v" }, null, -1))
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = ["aria-label"]
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fab fa-pinterest" }, null, -1))
const _hoisted_63 = [
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IsNotAuthenticated = _resolveComponent("IsNotAuthenticated")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t("footer.info.write-to-us")) + " ", 1),
        _createElementVNode("a", {
          "data-testid-help-mail": "",
          href: 'mailto:' + _ctx.$t('footer.contact.help-email')
        }, _toDisplayString(_ctx.$t("footer.contact.help-email")), 9, _hoisted_3)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, [
          _createVNode(_component_router_link, {
            to: "/",
            "aria-label": _ctx.$t('general.logo')
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: _imports_0,
                alt: _ctx.$t('general.logo')
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          }, 8, ["aria-label"])
        ]),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("footer.info.museum")), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("a", {
              "data-testid-phone": "",
              href: 'tel:' + _ctx.$t('footer.contact.phone').replace(/ /g, '')
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact.phone")), 1)
            ], 8, _hoisted_11)
          ]),
          _createElementVNode("span", _hoisted_13, [
            _createElementVNode("a", {
              "data-testid-mail": "",
              href: 'mailto:' + _ctx.$t('footer.contact.email')
            }, [
              _hoisted_15,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("footer.contact.email")), 1)
            ], 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("span", _hoisted_17, [
            _createElementVNode("a", {
              href: "https://www.facebook.com/kunsten.dk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.facebook')
            }, _hoisted_20, 8, _hoisted_18),
            _createElementVNode("a", {
              href: "https://www.linkedin.com/company/3083004",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.linkedin')
            }, _hoisted_23, 8, _hoisted_21),
            _createElementVNode("a", {
              href: "https://www.instagram.com/kunstendk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.instagram')
            }, _hoisted_26, 8, _hoisted_24),
            _createElementVNode("a", {
              href: "https://www.vimeo.com/kunsten",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.vimeo')
            }, _hoisted_29, 8, _hoisted_27),
            _createElementVNode("a", {
              href: "https://www.pinterest.dk/kunstendk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.pinterest')
            }, _hoisted_32, 8, _hoisted_30)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_router_link, {
            to: { path: '/search', query: { lang: _ctx.locale, page: '1' } }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.artworks")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode(_component_router_link, { to: "/artists" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.artists")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/themes" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.themes")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/acquisitions" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.acquisitions")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createVNode(_component_router_link, { to: "/exhibitions" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.exhibitions")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/about-collections" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.about-collections")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/my-collections" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("navigation.my-collections")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_IsNotAuthenticated, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: { name: 'LandingPage', query: { view: 'login' } } }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("navigation.log-in")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            "data-testid-visit-url": "",
            href: _ctx.$t('navigation.visit-url'),
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_ctx.$t("navigation.visit-kunsten")), 9, _hoisted_37)
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("a", {
            class: "pb-2",
            href: _ctx.$t('navigation.visit-url'),
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_ctx.$t("museum")) + " " + _toDisplayString(_ctx.$t("footer.info.museum")), 9, _hoisted_40),
          _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("footer.info.address")), 1),
          _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.$t("footer.info.postcode")), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("a", {
            class: "pb-0",
            href: 'tel:' + _ctx.$t('footer.contact.phone').replace(/ /g, '')
          }, _toDisplayString(_ctx.$t("footer.contact.phone")), 9, _hoisted_44),
          _createElementVNode("a", {
            class: "pb-2",
            href: 'mailto:' + _ctx.$t('footer.contact.email')
          }, _toDisplayString(_ctx.$t("footer.contact.email")), 9, _hoisted_45),
          _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.$t("footer.contact.cvr")), 1),
          _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t("footer.contact.ean")), 1),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("a", {
              href: "https://www.facebook.com/kunsten.dk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.facebook')
            }, _hoisted_51, 8, _hoisted_49),
            _createElementVNode("a", {
              href: "https://www.linkedin.com/company/3083004",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.linkedin')
            }, _hoisted_54, 8, _hoisted_52),
            _createElementVNode("a", {
              href: "https://www.instagram.com/kunstendk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.instagram')
            }, _hoisted_57, 8, _hoisted_55),
            _createElementVNode("a", {
              href: "https://www.vimeo.com/kunsten",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.vimeo')
            }, _hoisted_60, 8, _hoisted_58),
            _createElementVNode("a", {
              href: "https://www.pinterest.dk/kunstendk",
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": _ctx.$t('footer.pinterest')
            }, _hoisted_63, 8, _hoisted_61)
          ])
        ])
      ])
    ])
  ]))
}